import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatOption, MatSelect } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Role } from '../common/models/role';
import { AuthenticationService } from '../common/services/authentication.service';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { ExcelService } from '../dashboard-sql/excel.service';
import { DpiReductionAnalysisService } from './dpi-reduction-analysis.service';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { IncidentsDashboardViewModel } from '../common/models/incident-dashboard-filterparameter';
import { DPIREDUCTIONCOLUMS } from '../common/constants/labels';

@Component({
  selector: 'app-dpi-reduction-analysis',
  templateUrl: './dpi-reduction-analysis.component.html',
  styleUrls: ['./dpi-reduction-analysis.component.scss']
})
export class DpiReductionAnalysisComponent implements OnInit {
  title = 'DPI Reduction Analysis';
  DpiReductionCols = DPIREDUCTIONCOLUMS;
  loading = false;
  ValidationMsg = 'Please select From Date, To Date,Cluster, Site, Big Category.';
  showValidationMessage = false;
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  cluster: any;
  site: string[] = [];
  bigcategory: any;
  clustertooltip = [];
  sitetooltip = '';
  bigcategorytooltip = [];
  dpiAnalysisForm = new FormGroup({
    clusters: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
    YearlyControl: new FormControl(),
    YearControl: new FormControl()
  });

  clusterFiltertooltip = [];
  siteFiltertooltip = [];
  bigcategoryFiltertooltip = [];
  userFiltertooltip = [];
  role;
  @ViewChild('clusterControl', {static: false}) clusterControl: MatSelect;
  @ViewChild('siteControl', {static: false}) siteControl: MatSelect;
  @ViewChild('bigCategoryControl', {static: false}) bigCategoryControl: MatSelect;
  allSelected = false;
  siteAllSelected = false;
  bigCategoryAllSelected = false;
  clusterdefault: any;
  sitedefault = '';
  bigcategorydefault = [];
  showSuccess = false;
  filterParameter: any;
  dataAvailable = false;
  filteredDataSource = [];
  OverallDpiDataSource = [];
  pivotTableDetails = [];
  nofiltereddata = false;
  noRecords = 'No records';
  yearSelect = [];
  yearlySelect = [ 'H1', 'H2'];
  disableCluster = false;
  disableSite = false;
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;
  constructor(private dashboardService: DashboardSqlService, private dpiAnalysisService: DpiReductionAnalysisService, private excelService: ExcelService, private authenticateService: AuthenticationService) { }

  ngOnInit() {
    this.loading = true;
    this.setYear();
    this.getClusterSiteBigCategoryData();
    this.nofiltereddata = true;
    this.noRecords = '';
    this.loading = false;
  }

  setYear() {
    const currentYear = new Date().getFullYear();
    for (let i = 2020; i <= currentYear; i++) {
      this.yearSelect.push(i);
    }
  }

  commonfunctionSetDefault(tempArray: string[], bigArray: string[]) {
    this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.sitedefault = this.site[0];
    this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.bigcategorydefault = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;
    this.clustertooltip = this.clusterdefault ? this.clusterdefault : this.cluster;
    this.sitetooltip =  this.sitedefault;
    this.bigcategorytooltip = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;

    // if (this.cluster.length >1) {
    //   this.allSelected = true;
    // }

    // let siteAll = false;
    // if (this.site.length <= this.sitedefault.length) {
    //   siteAll = true;
    //   this.siteControl.options.forEach((item: MatOption) => {
    //     if (!item.selected) {
    //       siteAll = false;
    //     }
    //   });
    //   this.siteAllSelected = siteAll;
    // }

    // let bigCategoryAll = false;
    // if (this.bigcategory.length <= this.bigcategorydefault.length) {
    //   bigCategoryAll = true;
    //   this.bigCategoryControl.options.forEach((item: MatOption) => {
    //     if (!item.selected) {
    //       bigCategoryAll = false;
    //     }
    //   });
    //   this.bigCategoryAllSelected = bigCategoryAll;
    // }

    if (this.role === Role.qualityChampion) {
      this.disableSite = false;
      this.disableCluster = true;
    } else if (this.role === Role.globalAdmin || this.role === Role.qualityGlobalRead) {
      this.disableSite = false;
      this.disableCluster = false;
    } else {
      this.disableSite = true;
      this.disableCluster = true;
    }
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    factory = localStorage.getItem('factory');
    this.role = localStorage.getItem('role');
    const tempArray: string[] = [];
    this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        this.clusterdefault = clusterfilter.subregion;
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.subregion === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = clusterfilter.site;

        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
        }
      }
    });
    if (this.clusterdefault === '') {
      const clusterdata = [];
      this.loading = true;
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed[0];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterBasedOnRoleparsed[0] === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = this.site[0];
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (this.site[0] === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
        }
      } else {
        this.dashboardService.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata[0];
            this.clustersitebigcategoryArray.forEach(element => {
              if (clusterdata[0] === element.subregion) {
                tempArray.push(element.site);
              }
            });

            this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();

            const bigArray: string[] = [];
            this.clustersitebigcategoryArray.forEach(element => {
              if (this.site[0] === element.site) {
                bigArray.push(element.businessgroup);
              }
            });
            this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();

            if (this.role === Role.qualityChampion) {
              this.disableSite = false;
              this.disableCluster = true;
            } else if (this.role === Role.globalAdmin) {
              this.disableSite = false;
              this.disableCluster = false;
            } else {
              this.disableSite = true;
              this.disableCluster = true;
            }
          }
          this.loading = false;
        });
      }
    }
  }

  getClusterSiteBigCategoryData() {
    this.dashboardService.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
        this.showValidationMessage = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
        this.loading = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.loading = true;
    this.bigcategory = [];
    this.site = [];
    const tempArray: string[] = [];
    this.clustertooltip = [];
    this.sitetooltip = '';
    this.bigcategorytooltip = [];
    this.dpiAnalysisForm.get('sites').setValue(null);
    let clusterSelected = '';
    if (this.dpiAnalysisForm.get('clusters').value !== null && this.dpiAnalysisForm.get('clusters').value.length > 0) {
      clusterSelected = this.dpiAnalysisForm.get('clusters').value;
      // this.clustertooltip = clusterSelected;
      // let clusterAll = true;
      // this.clusterControl.options.forEach((item: MatOption) => {
      //   if (!item.selected) {
      //     clusterAll = false;
      //   }
      // });
      // this.allSelected = clusterAll;
      // clusterSelected.forEach(clusterelement => {
      this.clustersitebigcategoryArray.forEach(element => {
          if (clusterSelected === element.subregion) {
            tempArray.push(element.site);
          }
        });
      // });
      this.site = tempArray; // tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.sitedefault = tempArray[0];
      this.sitetooltip = this.sitedefault;
      setTimeout(() => {
        this.loadBigCategory();
      }, 2000);
    } else {
      this.loading = false;
    }
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  clearData() {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  loadBigCategory() {
    this.bigcategory = [];
    this.dpiAnalysisForm.get('bigcategories').setValue(null);
    this.sitetooltip = '';
    this.bigcategorytooltip = [];
    let siteSelected = '';
    const tempBigCategoryArray: string[] = [];
    if (this.dpiAnalysisForm.get('sites').value !== null && this.dpiAnalysisForm.get('sites').value.length > 0) {
      siteSelected = this.dpiAnalysisForm.get('sites').value;
      this.sitetooltip = siteSelected;
      // siteSelected.forEach(siteelement => {
      this.clustersitebigcategoryArray.forEach(element => {
          if (siteSelected === element.site) {
            tempBigCategoryArray.push(element.businessgroup);
          }
      });
      // });
      this.bigcategory = tempBigCategoryArray; // .map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.bigcategorydefault = this.bigcategory;
      this.bigcategorytooltip = this.bigcategorydefault;
      // let siteAll = true;
      // this.siteControl.options.forEach((item: MatOption) => {
      //   if (!item.selected) {
      //     siteAll = false;
      //   }
      // });
      // this.siteAllSelected = siteAll;

      let bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.loading = false;
    }
  }

  // Authorization
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.globalAdmin) {
      return true;
    } else {
      return false;
    }
  }

  optionClick() {
    let newStatus = true;
    this.clusterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  toggleSiteAllSelection() {
    if (this.siteAllSelected) {
      this.siteControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.siteControl.options.forEach((item: MatOption) => item.deselect());
      this.sitetooltip = '';
      this.bigcategorytooltip = [];
    }
  }

  optionsiteClick() {
    let newStatus = true;
    this.siteControl.options.forEach((item: MatOption) => {
    if (!item.selected) {
        newStatus = false;
      }
    });
    this.siteAllSelected = newStatus;
  }

  toggleBigCategoryAllSelection() {
   if (this.bigCategoryAllSelected) {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.deselect());
      this.bigcategorytooltip = [];
    }
  }

  optionBigCategoryClick() {
    let newStatus = true;
    this.bigCategoryControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.bigCategoryAllSelected = newStatus;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.clusterControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.clusterControl.options.forEach((item: MatOption) => item.deselect());
      this.clustertooltip = [];
      this.sitetooltip = '';
      this.bigcategorytooltip = [];
    }
  }

  generateReport() {
    this.loading = true;
    this.showValidationMessage = false;
    this.showSuccess = false;
    const year = + this.dpiAnalysisForm.get('YearControl').value;
    console.log(year);
    let fromDate = '';
    let toDate = '';
    if (this.dpiAnalysisForm.get('YearlyControl').value === 'H1' || this.dpiAnalysisForm.get('YearlyControl').value === null) {
      fromDate = '01/01/' + year; // for H1, consider the date between 1-Jul to 31-dec of the selected year
    } else {
      fromDate = '07/01/' + year; // for H2, consider the date between 1-Jul to 30-Jun of the selected (year + 1)
    }
    if (this.dpiAnalysisForm.get('YearlyControl').value === 'H1') {
      toDate = '06/30/' + year; // for H1, todate should be 31-dec of the selected year
    } else {
      toDate = '12/31/' + year; // for H2, todate should be 30-Jun of the selected (year + 1)
    }
    const selectedFromDate = fromDate;
    const selectedTodate = toDate;
    const selectedcluster: string[] = []; selectedcluster.push(this.dpiAnalysisForm.get('clusters').value);
    const selectedsite: string[] = []; selectedsite.push(this.dpiAnalysisForm.get('sites').value);
    const selectedbigcategory = this.dpiAnalysisForm.get('bigcategories').value;
    if (selectedFromDate === null || selectedFromDate === '' || selectedTodate === null || selectedTodate === ''
      || selectedcluster === null || selectedcluster.length === 0
      || selectedsite === null || selectedsite.length === 0
      || selectedbigcategory === null || selectedbigcategory === '' || selectedbigcategory.length === 0) {
      if (!this.isAuthorized) {
        this.ValidationMsg = 'Please select From Date, To Date, Big Category.';
      } else {
        this.ValidationMsg = 'Please select From Date, To Date, Cluster, Site, Big Category.';
      }
      this.showValidationMessage = true;
      this.loading = false;
    } else {
      this.filterParameter = {
        fromDate: new Date(selectedFromDate).toLocaleDateString('en-US'),
        toDate: new Date(selectedTodate).toLocaleDateString('en-US'),
        bigcategory: selectedbigcategory,
        cluster: selectedcluster,
        site: selectedsite,
      };
      this.getDpiReductionAnalysisReportData(this.filterParameter);
    }
  }

  getDpiReductionAnalysisReportData(filterParameter: IncidentsDashboardViewModel) {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dpiAnalysisService.getDpiReductionAnalysisData(filterParameter).subscribe((response) => {
      this.dataAvailable = true;
      if (response !== null && response.length > 1) {
        const dpireductiondata = [];
        const overallDpireductiondata = [];
        response.forEach(e => {
          let object = {};
          object = {
            defectmodeaggregation: e.defectmodeaggregation,
            level0: e.leveL0,
            groupone: e.groupOneDPI,
            totalDpi: e.totalDPI,
            grouptwo: e.groupTwoDPI,
            dpireductionpercentage: e.dpiReduction
          };
          if (e.leveL0 === 'Overall DPI' || e.leveL0 === 'Project Coverage %' ) {
            if (e.leveL0 === 'Project Coverage %') {
              object['level0'] = 'Project Coverage % (Do,Check,Act,Done)';
            }
            overallDpireductiondata.push(object);
          } else {
            dpireductiondata.push(object);
          }
        });
        this.OverallDpiDataSource = overallDpireductiondata;
        this.filteredDataSource = dpireductiondata;
        this.pivotTableDetails = dpireductiondata;
        this.dataSource = new MatTableDataSource(this.filteredDataSource);
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.filterData();
      } else {
        this.loading = false;
        this.ValidationMsg = 'No data available.';
        this.showValidationMessage = true;
        this.dataAvailable = false;
        this.noRecords = '';
        this.nofiltereddata = true;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get report data. Please try again after sometime.';
      this.showValidationMessage = true;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.loading = false;
    });
  }

  filterData() {
    this.showSuccess = false;
    if (this.pivotTableDetails != null && this.pivotTableDetails.length > 0) {
      this.filteredDataSource = this.pivotTableDetails;
      if (this.filteredDataSource.length === 0) {
        this.noRecords = 'No records';
        this.nofiltereddata = true;
      } else {
        const clusterArray = [];
        const siteArray = [];
        const bigcategoryArray = [];
        const userArray = [];
        this.filteredDataSource.forEach(x => {
          clusterArray.push(x.cluster);
          siteArray.push(x.sites);
          bigcategoryArray.push(x.bigcategory);
          userArray.push(x.createdby);
        });
        /*
        this.clusterfilter = clusterArray.filter((n, i) => clusterArray.indexOf(n) === i);
        this.sitefilter = siteArray.filter((n, i) => siteArray.indexOf(n) === i);
        this.bigcategoryfilter = bigcategoryArray.filter((n, i) => bigcategoryArray.indexOf(n) === i);
        this.userfilter = userArray.filter((n, i) => userArray.indexOf(n) === i);
        this.clusterfilterdefault = this.clusterfilter;
        this.sitefilterdefault = this.sitefilter;
        this.userfilterdefault = this.userfilter;
        this.bigcategoryfilterdefault = this.bigcategoryfilter;
        this.clusterFiltertooltip = this.clusterfilterdefault;
        this.siteFiltertooltip = this.sitefilterdefault;
        this.bigcategoryFiltertooltip = this.bigcategoryfilterdefault;
        this.userFiltertooltip = this.userfilterdefault;
        this.bigCategoryFilterSelectedAll = true;
        this.userFilterSelectedAll = true;
        this.siteFilterSelectedAll = true;
        this.clusterFilterSelectedAll = true;
        */
        this.nofiltereddata = false;
      }
    }
  }
}
